import React from "react";

const SvgLandmarkLogomarkMono = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 87 87" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.493 67.528A43.41 43.41 0 107.307 19.292a43.41 43.41 0 0072.186 48.236zM61.78 9.54l19.31 22.52a42.07 42.07 0 011.61 13.36 34.859 34.859 0 01-2.58 11.48H62.54L41.88 31.44l19.9-21.9zm-1.52 51.81L36.21 31.82 26.19 42.24v-4h-15v20.43l-3 3S19.54 82.93 43.7 82.93c24.16 0 34.45-21.58 34.45-21.58H60.26z"
        fill="currentcolor"
      />
    </svg>
  );
};

export default SvgLandmarkLogomarkMono;
